import {
  EmailMessageCheckUpIssueType,
  MESSAGE_STR_TYPE_CONTENTSCAMPAIGN,
  STORE_KEY_ACCOUNT,
  STORE_KEY_ID_LIST,
  STORE_KEY_USER
} from 'Constants/'
import getIntl from 'Helpers/intl'
import { storeGet } from 'Helpers/localStorage'
import { logAppError } from 'Helpers/logger'
import {
  modalAlertMessageUpdate,
  modalBuyCollaboration,
  modalCheckup,
  modalConfirmChangeDefaultMessageState,
  modalConfirmCopy,
  modalConfirmCopyHtml,
  modalDefaultFields,
  modalNoEdit,
  modalNotificationMessage
} from 'Pages/OverviewMessage/recoil/state/modal'
import { evalCondition } from 'mailup-react-helpers'
import {
  TOAST_VARIANT_ERROR,
  TOAST_VARIANT_SUCCESS,
  TOAST_VARIANT_WARNING,
  UPLOADER_VARIANT_DANGER,
  UPLOADER_VARIANT_DEFAULT,
  UPLOADER_VARIANT_UPLOADING,
  toastShow
} from 'mailup-web-components'
import {
  addNewTag,
  addSilencedAlerts,
  checkImages,
  copyHtmlMessage,
  copyMessage,
  createLandingPages,
  downloadAttachment,
  fastCheck,
  getActiveMessage,
  getAllTags,
  getAttachmentsInfo,
  getCampaignsInfo,
  getDynamicFields,
  getDynamicFieldsListValue,
  getEndpointsAttachToList,
  getEndpointsAttachToMessage,
  getEndpointsList,
  getEntitiesThatUseMessage,
  getLinkedEntities,
  getMandatorySenderAction,
  getMessageContent,
  getMessageDetails,
  getMessageHtmlExport,
  getMessagePdfExport,
  getRequiresUpdateWelcomeSeries,
  getScreenshot,
  getSilencedAlerts,
  getTrackingInfoCustomParams,
  getUploadFeedback,
  getWelcomeSeries,
  getWhitelist,
  initMandatorySenderWithAnagraphicDataAction,
  isSendingMessage,
  modalCheck,
  setActiveMessageOfType,
  setMessageType,
  setWelcomeMessage,
  updateAttachmentsConfiguration,
  updateEndpoints,
  updateMessage,
  updateMessageDynamicFields,
  updateWelcomeSeries,
  updateWhitelist,
  uploadAttachment,
  validateAttachments,
  validateMessageType
} from '../actions/actions'
import {
  attachmentsState,
  collaborationState,
  footerState,
  hasWelcomeSeriesState,
  messageState,
  notificationState,
  overviewThumbnailState
} from '../state/message'
import { pageState } from '../state/page'

import { beAccountsApiGetAccountCustomSettings } from 'Api/beAccountsApi'
import { collaborationApiGetLoginData } from 'Api/collaborationApi'
import {
  LOGIN_TYPE_WEBLOGIN,
  MESSAGE_STR_TYPE_CONFIRMATION,
  MESSAGE_STR_TYPE_GENERIC,
  MESSAGE_STR_TYPE_WELCOME,
  MESSAGE_TYPE_CONFIRMATION,
  MESSAGE_TYPE_WELCOME,
  STORE_KEY_LOGIN_TYPE
} from 'Constants/index'
import { pendoTrack } from 'Helpers/pendoTracking'
import {
  dynamicFiledListState,
  endpointsListState,
  tagsListState
} from '../state/list'
import { uploaderState } from '../state/uploader'

export const cleanupCallback = ({ reset }) => async () => {
  reset(pageState)
  reset(messageState)
  reset(notificationState)
  reset(collaborationState)
  reset(attachmentsState)
  reset(footerState)
  reset(uploaderState)
  reset(endpointsListState)
  reset(hasWelcomeSeriesState)
  reset(modalConfirmChangeDefaultMessageState)
  reset(modalConfirmCopy)
  reset(modalConfirmCopyHtml)
  reset(modalNoEdit)
  reset(modalDefaultFields)
  reset(modalNotificationMessage)
  reset(modalBuyCollaboration)
  reset(modalAlertMessageUpdate)
  reset(modalCheckup)
  reset(modalConfirmChangeDefaultMessageState)
}

export const initCallback = ({ set }) => async (id, { op, content }) => {
  set(pageState, prev => ({ ...prev, loading: true }))

  try {
    const [
      {
        Subject,
        Notes,
        PreHeader,
        Tags,
        Embed,
        MessageType,
        HasThumbnail,
        IsBee,
        UpdateDate,
        TrackingInfo,
        UseDynamicField,
        Fields,
        attachmentNames
      },

      isSending,
      checkup,
      selectedEndpointsList,
      tagsList,
      attachmentsMetadata,
      { forms: linkedForms, entities },
      hasWelcomeSeriesWorkflow
    ] = await Promise.all([
      getMessageDetails(id),
      isSendingMessage(id),
      fastCheck(id),
      getEndpointsAttachToMessage(id),
      getAllTags(),
      getAttachmentsInfo(id),
      getLinkedEntities(id),
      getWelcomeSeries()
    ])

    const isUsed = linkedForms.length > 0

    const canSend =
      evalCondition('NOT uo:NOSEND') &&
      MessageType !== MESSAGE_STR_TYPE_CONTENTSCAMPAIGN
    const canQuickSend = evalCondition('NOT uo:NOSEND')

    if (isSending) {
      set(pageState, prev => ({
        ...prev,
        inlineMessage: getIntl().formatMessage({
          id: 'Load.EmailMessageList.MessageIsOnSentWarning'
        }),
        inlineMessageSeverity: 'warning'
      }))
    }

    if (Embed) {
      const imageCheck = await checkImages(id)
      if (!imageCheck) {
        set(pageState, prev => ({ ...prev, imageCheckFail: true }))
      }
    }

    if (MessageType === MESSAGE_STR_TYPE_CONTENTSCAMPAIGN) {
      const { Id: idCampaign } = await getCampaignsInfo(id)
      set(messageState, prev => ({
        ...prev,
        idCampaign
      }))
    }

    if (MessageType === MESSAGE_STR_TYPE_WELCOME) {
      set(hasWelcomeSeriesState, hasWelcomeSeriesWorkflow)
    }

    if (
      MessageType === MESSAGE_STR_TYPE_CONFIRMATION ||
      MessageType === MESSAGE_STR_TYPE_WELCOME
    ) {
      try {
        const activeMessage = await getActiveMessage(
          MessageType === MESSAGE_STR_TYPE_WELCOME
            ? MESSAGE_TYPE_WELCOME
            : MESSAGE_TYPE_CONFIRMATION
        )

        if (activeMessage === parseInt(id)) {
          set(notificationState, prev => ({ ...prev, activeMessage: true }))
        }
      } catch (error) {
        console.error('### error', error)
        logAppError({
          Component: 'OverviewMessage',
          Method: 'initCallback - getActiveMessage',
          appError: error
        })
        set(pageState, prev => ({
          ...prev,
          error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
          severity: 'danger'
        }))
      }
    }

    //

    const attachments = attachmentNames.map(name => {
      const meta = attachmentsMetadata.find(({ FileName }) => FileName === name)
      return {
        name: name,
        size: meta ? meta.FileSize : 0,
        error: !meta
      }
    })

    const existingTags = Tags.filter(t =>
      tagsList.Items.find(({ Id: tagId }) => tagId === t)
    )

    set(tagsListState, prev => ({ ...prev, tagsList: tagsList.Items }))
    set(pageState, prev => ({
      ...prev,
      title: Subject,
      loaded: true,
      newFromLanding: op === 'newFromLanding',
      newFromLandingWithForm: op === 'newFromLanding' && content === 'form'
    }))

    if (!selectedEndpointsList) {
      logAppError({
        Component: 'OverviewMessage',
        Method: 'initCallback',
        appError: {
          ErrorName: 'selectedEndpointsList is empty',
          ErrorMessage: 'selectedEndpointsList is empty',
          ErrorStack: selectedEndpointsList
        },
        Data: JSON.stringify({ selectedEndpointsList })
      })
    }

    set(messageState, prev => ({
      ...prev,
      id: parseInt(id),
      // title: Subject,
      isSending,
      checkup,
      canSend,
      canQuickSend,
      messageType: MessageType,
      hasThumbnail: HasThumbnail,
      isBee: IsBee,
      updateDate: UpdateDate,
      notes: Notes,
      tags: existingTags,
      preHeader: PreHeader,
      subject: Subject,
      useDynamicField: UseDynamicField,
      fields: Fields,
      embed: Embed,
      customParams: TrackingInfo.CustomParams,
      trackingInfoEnabled: TrackingInfo.Enabled,
      trackingInfoProtocols: TrackingInfo.Protocols,
      selectedEndpointsList: selectedEndpointsList.Items.map(e => e.IdContent),
      linkedForms,
      isUsed,
      linkedEntities: entities
    }))
    set(collaborationState, [id])
    set(attachmentsState, {
      attachments,
      attachmentsMetadata
    })
  } catch (error) {
    console.error('### error', error)
    logAppError({
      Component: 'OverviewMessage',
      Method: 'initCallback',
      appError: error
    })
    set(pageState, prev => ({
      ...prev,
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger'
    }))
  }

  set(pageState, prev => ({ ...prev, loading: false }))
}

export const saveMessageCallback = ({ set, snapshot }) => async () => {
  set(pageState, prev => ({ ...prev, loading: true }))

  const {
    id,
    subject,
    preHeader,
    notes,
    tags,
    embed,
    useDynamicField,
    fields,
    customParams,
    trackingInfoEnabled,
    trackingInfoProtocols,
    endpointsToggle,
    selectedEndpointsList,
    baseEndpoint, // un solo elemento
    messageType
  } = await snapshot.getPromise(messageState)
  const { notificationEnable } = await snapshot.getPromise(notificationState)

  const endPointsAttachedToMessage =
    selectedEndpointsList && selectedEndpointsList.length > 0
      ? selectedEndpointsList.map(e => e)
      : endpointsToggle
      ? [baseEndpoint] // se advanced personalization attiva e nessun endpoint selezionato... salvo basic
      : [] //  se advanced personalization disattiva svuota elenco endpoint

  try {
    const isSending = await isSendingMessage(id)
    if (!isSending) {
      await updateEndpoints(id, endPointsAttachedToMessage)

      if (
        messageType === MESSAGE_STR_TYPE_WELCOME ||
        messageType === MESSAGE_STR_TYPE_CONFIRMATION
      ) {
        if (!notificationEnable) {
          await setMessageType(id, MESSAGE_STR_TYPE_GENERIC)
        } else {
          if (messageType === MESSAGE_STR_TYPE_WELCOME) {
            await setWelcomeMessage()
          }
          await setMessageType(id, messageType)
        }
      }

      await updateMessage(id, {
        subject,
        preHeader,
        notes,
        tags,
        embed,
        useDynamicField,
        fields,
        customParams,
        trackingInfoEnabled,
        trackingInfoProtocols
      })

      set(pageState, prev => ({ ...prev, title: subject }))
      set(messageState, prev => ({
        ...prev,
        isDirty: false
      }))

      // modal check & silenced alerts
      const [
        mdCheck,
        workflows,
        silencedAlerts,
        whiteList,
        checkup
      ] = await Promise.all([
        modalCheck(id),
        getEntitiesThatUseMessage(id),
        getSilencedAlerts(),
        getWhitelist(id),
        fastCheck(id)
      ])

      const silencedAlertsArray =
        silencedAlerts.DataValue && silencedAlerts.DataValue !== ''
          ? JSON.parse(silencedAlerts.DataValue)
          : []
      if (silencedAlertsArray.length > 0) {
        silencedAlertsArray.forEach(e => {
          e.silenced =
            e.disableForMessage.length > 0
              ? e.disableForMessage.includes(id.toString())
              : !e.enable
        })
      }
      Object.keys(EmailMessageCheckUpIssueType).forEach(e => {
        const index = silencedAlertsArray.findIndex(
          f => f.issueType === EmailMessageCheckUpIssueType[e]
        )
        if (index === -1) {
          const obj = {
            silenced: false,
            issueType: EmailMessageCheckUpIssueType[e]
          }
          silencedAlertsArray.push(obj)
        }
      })
      set(modalCheckup, prev => ({
        ...prev,
        silencedAlertsArray: silencedAlertsArray
      }))
      // visualizza la modale
      // in base ai campi dinamici
      // - opzione attiva
      // - campi sbagliati
      let showModal = false
      let newWrongTags = []
      if ('CheckFields' in mdCheck) {
        const seeOption =
          mdCheck.CheckFields.IsDynamicFieldsEnabled === false &&
          mdCheck.CheckFields.ContainsDynamicFields === true
        set(modalCheckup, prev => ({
          ...prev,
          dynamicFieldsOptionEnabled: seeOption
        }))
        showModal = seeOption

        if (mdCheck.CheckFields.WrongDynamicTags.length > 0) {
          const whitelisted =
            whiteList.DataValue && whiteList.DataValue !== ''
              ? JSON.parse(whiteList.DataValue)
              : []

          newWrongTags = mdCheck.CheckFields.WrongDynamicTags.slice(0)
          newWrongTags = newWrongTags.filter(m => m.Value !== '[]')

          newWrongTags.forEach(e => {
            const pendoProps = {
              IdMessage: id,
              Value: e.Value.replace(/[[\]]/g, ''),
              Location: e.Location,
              // ===
              //  'Header'
              //   ? 'Subject'
              //   : e.Location ===
              //   'Summary'
              //     ? 'Summary'
              //     : 'Body',
              SilentMode: whitelisted.includes(e.Value.replace(/[[\]]/g, '')),
              AlertStatus: 'Enabled',
              Source: 'overview'
            }
            pendoTrack('Checkup - dynamic field - impression', pendoProps)
          })
          const tmpWhiteListItems = []
          whitelisted.forEach(element => {
            const i = newWrongTags.findIndex(
              e => e.Value.replace(/[[\]]/g, '') === `${element}`
            )
            if (i > -1) {
              newWrongTags.splice(i, 1)
              tmpWhiteListItems.push(element)
            }
          })

          set(modalCheckup, prev => ({
            ...prev,
            wrongDynamicTags: newWrongTags,
            addToWhiteList: tmpWhiteListItems
          }))
          /* opzione disabilitata */
          if (!showModal) {
            /* prendo in considerazione i campi sabgliati */
            showModal = newWrongTags.length > 0
          }
        }
      }

      if (mdCheck) {
        set(modalCheckup, prev => ({
          ...prev,
          checkBlacklistResult: mdCheck.CheckBlacklistResult,
          checkLiquidCode: mdCheck.CheckLiquidCode,
          checkAttachments: mdCheck.CheckAttachments,
          checkDynamicContents: mdCheck.CheckDynamicContents,
          checkSize: mdCheck.CheckSize,
          checkContent: mdCheck.CheckContent,
          checkLinksWoTracking: mdCheck.CheckLinksWoTracking,
          checkUnsubscribeLink: mdCheck.CheckUnsubscribeLink,
          checkMaxSize: mdCheck.CheckMaxSize,
          checkPreheader: mdCheck.CheckPreheader,
          checkWebAnalytics: mdCheck.CheckWebAnalytics,
          checkWorkflowWarning: workflows,
          checkCustomDomainCustomizable: mdCheck.CustomDomainCustomizable
        }))
      }
      // BLICCHI DA MOSTRARE IN BASE
      // AI SETTINGS E AGLI ALERTS
      // improvements
      const PreheaderInfo =
        !mdCheck.CheckPreheader &&
        !silencedAlertsArray.find(
          e => e.issueType === EmailMessageCheckUpIssueType.PreheaderInfo
        ).silenced
      const WebAnalyticsTrackingInfo =
        !mdCheck.CheckWebAnalytics &&
        !silencedAlertsArray.find(
          e =>
            e.issueType ===
            EmailMessageCheckUpIssueType.WebAnalyticsTrackingInfo
        ).silenced
      // potential
      const LinkTrackingWarning =
        !mdCheck.CheckLinksWoTracking &&
        !silencedAlertsArray.find(
          e => e.issueType === EmailMessageCheckUpIssueType.LinkTrackingWarning
        ).silenced

      const UnsubscribeLinkWarning =
        !mdCheck.CheckUnsubscribeLink &&
        !silencedAlertsArray.find(
          e =>
            e.issueType === EmailMessageCheckUpIssueType.UnsubscribeLinkWarning
        ).silenced

      const MaxSizeInfo =
        !mdCheck.CheckMaxSize.Check &&
        !silencedAlertsArray.find(
          e => e.issueType === EmailMessageCheckUpIssueType.MaxSizeInfo
        ).silenced

      const BlackListUrlWarning =
        mdCheck.CheckBlacklistResult.Action === 1 &&
        !silencedAlertsArray.find(
          e => e.issueType === EmailMessageCheckUpIssueType.BlackListUrlWarning
        ).silenced

      const WorkflowWarning =
        workflows &&
        !silencedAlertsArray.find(
          e => e.issueType === EmailMessageCheckUpIssueType.WorkflowWarning
        ).silenced

      const LinkCheckWarning = !silencedAlertsArray.find(
        e =>
          e.issueType ===
            EmailMessageCheckUpIssueType.WebAnalyticsTrackingInfo ||
          e.issueType === EmailMessageCheckUpIssueType.PreheaderInfo
      ).silenced

      const DynamicFieldsWarning =
        newWrongTags &&
        newWrongTags.length > 0 &&
        !silencedAlertsArray.find(
          e => e.issueType === EmailMessageCheckUpIssueType.DynamicFieldsWarning
        ).silenced

      const objArray = [
        {
          key: 'LinkCheckWarning',
          issueType: 6,
          toDisplay: LinkCheckWarning,
          section: 'INFO'
        },
        {
          key: 'LinkTrackingWarning',
          issueType: 7,
          toDisplay: LinkTrackingWarning,
          section: 'POTENTIAL'
        },
        {
          key: 'UnsubscribeLinkWarning',
          issueType: 8,
          toDisplay: UnsubscribeLinkWarning,
          section: 'POTENTIAL'
        },
        {
          key: 'DynamicFieldsWarning',
          issueType: 9,
          toDisplay: DynamicFieldsWarning,
          section: 'POTENTIAL'
        },
        {
          key: 'WorkflowWarning',
          issueType: 10,
          toDisplay: WorkflowWarning,
          section: 'POTENTIAL'
        },
        {
          key: 'BlackListUrlWarning',
          issueType: 11,
          toDisplay: BlackListUrlWarning,
          section: 'POTENTIAL'
        },
        {
          key: 'PreheaderInfo',
          issueType: 12,
          toDisplay: PreheaderInfo,
          section: 'INFO'
        },
        {
          key: 'MaxSizeInfo',
          issueType: 13,
          toDisplay: MaxSizeInfo,
          section: 'POTENTIAL'
        },
        {
          key: 'WebAnalyticsTrackingInfo',
          issueType: 14,
          toDisplay: WebAnalyticsTrackingInfo,
          section: 'INFO'
        }
      ]
      // [
      //   {
      //     "issueType": 9,
      //     "disableForMessage": [],
      //     "enable": true
      //   }
      // ]
      // mostrati e, eventualmente,
      // da disabilitare per il messaggio corrente
      const toDisplay = objArray.filter(e => e.toDisplay)
      set(modalCheckup, prev => ({
        ...prev,
        blockToDisplay: toDisplay
      }))

      // save fast checkup
      set(messageState, prev => ({
        ...prev,
        checkup
      }))

      // show modal if error
      if (
        (checkup &&
          (checkup.blocking > 0 ||
            checkup.potential > 0 ||
            checkup.improvements > 0)) ||
        showModal
      ) {
        toDisplay.length > 0 &&
          set(modalCheckup, prev => ({
            ...prev,
            show: true
          }))
      }
    } else {
      // page disabled
      set(messageState, prev => ({
        ...prev,
        isSending
      }))

      // show alert modal
      set(modalAlertMessageUpdate, prev => ({
        ...prev,
        default: true
      }))
      return false // message isSending
    }

    set(pageState, prev => ({ ...prev, loading: false }))
    return true
  } catch (error) {
    console.error('### error', error)
    logAppError({
      Component: 'OverviewMessage',
      Method: 'saveMessageCallback',
      appError: error
    })
    set(pageState, prev => ({
      ...prev,
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger'
    }))
  }

  set(pageState, prev => ({ ...prev, loading: false }))
}

export const sendingMessageCallback = ({ set }) => async id => {
  set(pageState, prev => ({ ...prev, loading: true }))

  try {
    const isSending = await isSendingMessage(id)

    set(messageState, prev => ({
      ...prev,
      isSending
    }))
    set(pageState, prev => ({ ...prev, loading: false }))

    return isSending
  } catch (error) {
    console.error('### error', error)
    logAppError({
      Component: 'OverviewMessage',
      Method: 'sendingMessageCallback',
      appError: error
    })
    set(pageState, prev => ({
      ...prev,
      loading: false,
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger'
    }))
  }
}

export const confirmCopyCallback = ({ set }) => async (id, html, history) => {
  set(pageState, prev => ({ ...prev, loading: true }))
  if (!html) {
    set(modalConfirmCopy, false)
  } else {
    set(modalConfirmCopyHtml, false)
  }

  const intl = getIntl()
  const { Username } = storeGet(STORE_KEY_USER)
  const date = new Date(Date.now())
    .toISOString()
    .replace('T', ' ')
    .replace(/\.\d+Z/, ' UTC')

  const notes = intl.formatMessage(
    { id: 'Load.Messages.CopyNotesUnknown' },
    {
      0: id,
      1: Username,
      2: date
    }
  )

  try {
    if (!html) {
      await copyMessage(id, notes)
    } else {
      await copyHtmlMessage(id, notes)
    }
    history.push('/messages/email/saved')
  } catch (error) {
    console.error('### error', error)
    logAppError({
      Component: 'OverviewMessage',
      Method: 'confirmCopyCallback',
      appError: error
    })
    set(pageState, prev => ({
      ...prev,
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger'
    }))
  }

  set(pageState, prev => ({ ...prev, loading: false }))
}

export const initModalNotificationMessageCallback = ({ set }) => async id => {
  set(pageState, prev => ({ ...prev, loading: true }))

  try {
    const checkValidateConfirmation = await validateMessageType(
      id,
      MESSAGE_STR_TYPE_CONFIRMATION
    )

    const checkValidateWelcome = await validateMessageType(
      id,
      MESSAGE_STR_TYPE_WELCOME
    )

    let selectedMessageType

    if (!checkValidateConfirmation && checkValidateWelcome) {
      selectedMessageType = MESSAGE_STR_TYPE_WELCOME
    } else if (checkValidateConfirmation && !checkValidateWelcome) {
      selectedMessageType = MESSAGE_STR_TYPE_CONFIRMATION
    }

    set(modalNotificationMessage, prev => ({
      ...prev,
      show: true,
      isEnableConfirmationRadio: checkValidateConfirmation,
      isEnableWelcomeRadio: checkValidateWelcome,
      selectedMessageType
    }))
  } catch (error) {
    console.error('### error', error)
    logAppError({
      Component: 'OverviewMessage',
      Method: 'initModalNotificationMessageCallback',
      appError: error
    })
    set(pageState, prev => ({
      ...prev,
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger'
    }))
  }
  set(pageState, prev => ({ ...prev, loading: false }))
}

export const saveAsNotificationMessageCallback = ({ set, snapshot }) => async (
  selectedMessageType,
  enableNotification
) => {
  const { id } = await snapshot.getPromise(messageState)

  set(modalNotificationMessage, prev => ({ ...prev, show: false }))
  set(pageState, prev => ({ ...prev, loading: true }))

  try {
    if (selectedMessageType === MESSAGE_STR_TYPE_WELCOME) {
      await setWelcomeMessage()
    }

    await setMessageType(id, selectedMessageType)

    if (enableNotification) {
      await setActiveMessageOfType(id, selectedMessageType)
      if (selectedMessageType === MESSAGE_STR_TYPE_WELCOME) {
        const requiresUpdateWelcomeSeries = await getRequiresUpdateWelcomeSeries()
        if (requiresUpdateWelcomeSeries) {
          await updateWelcomeSeries(+id)
        }
      }
    }

    set(messageState, prev => ({
      ...prev,
      messageType: selectedMessageType
    }))
  } catch (error) {
    console.error('### error', error)
    logAppError({
      Component: 'OverviewMessage',
      Method: 'saveAsNotificationMessageCallback',
      appError: error
    })
    set(pageState, prev => ({
      ...prev,
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger'
    }))
  }
  set(pageState, prev => ({ ...prev, loading: false }))
}

export const createLandingPagesCallback = ({ set }) => async (
  id,
  onSuccess
) => {
  set(pageState, prev => ({ ...prev, loading: true }))
  try {
    const { Id } = await createLandingPages(id)

    if (typeof onSuccess === 'function') {
      onSuccess(Id)
    }
  } catch (error) {
    console.error('### error', error)
    logAppError({
      Component: 'OverviewMessage',
      Method: 'createLandingPagesCallback',
      appError: error
    })
    set(pageState, prev => ({
      ...prev,
      loading: false,
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger'
    }))
  }
  set(pageState, prev => ({ ...prev, loading: false }))
}

export const addNewTagCallback = ({ set, snapshot }) => async pTagName => {
  const { tags: oldTags } = await snapshot.getPromise(messageState)

  try {
    const newTag = await addNewTag(pTagName)
    const tagsList = await getAllTags()

    // update list with new tag
    set(tagsListState, prev => ({ ...prev, tagsList: tagsList.Items }))

    // add new tag to msg state
    set(messageState, prev => ({
      ...prev,
      tags: [...oldTags, newTag.Id],
      isDirty: true
    }))
  } catch (error) {
    console.error('### error', error)
    logAppError({
      Component: 'OverviewMessage',
      Method: 'addNewTagCallback',
      appError: error
    })
    set(pageState, prev => ({
      ...prev,
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger'
    }))
  }
}

export const getCollaborationLoginDataCallback = ({ snapshot, set }) => async (
  idMessage,
  idProject,
  subject,
  hideResolvedThreads
) => {
  set(pageState, prev => ({
    ...prev,
    fetchingResults: true
  }))

  try {
    const account = storeGet(STORE_KEY_ACCOUNT)

    const IsWhiteLabel = evalCondition('co:WHITELABEL')

    const projectUrl = `https://${
      account.Domain
    }/frontend/nl_preview_window.aspx?idNL=${idMessage}&fc=${btoa(
      `${idMessage}`
    )}&hideAtt=1`

    const { AppName, LogoutUrl } = await beAccountsApiGetAccountCustomSettings()

    const customizations = IsWhiteLabel
      ? {
          customizations: [
            {
              Key: 'companylogourl',
              Value: `https://${account.Domain}/img/ApplicationLogo.jpg`
            },
            { Key: 'companyname', Value: AppName },
            { Key: 'companyurl', Value: LogoutUrl }
          ]
        }
      : {}

    const data = idProject
      ? {
          IdProject: idProject,
          navigation: 'True',
          hideresolvedthreads: hideResolvedThreads ? 'True' : 'False',
          ...customizations
        }
      : {
          projectReference: `NL_${idMessage}`,
          htmlUrl: projectUrl,
          projectName: subject,
          ...customizations
        }

    const result = await collaborationApiGetLoginData(data)
    return result
  } catch (error) {
    logAppError({
      Component: 'OverviewMessage',
      Method: 'getCollaborationLoginDataCallback',
      appError: error
    })

    return false
  } finally {
    set(pageState, prev => ({
      ...prev,
      fetchingResults: false
    }))
  }
}

export const getMessageContentCallback = ({ set }) => async pIdMessage => {
  try {
    const resp = await getMessageContent(pIdMessage)
    set(messageState, prev => ({
      ...prev,
      embedItems: resp.Items
    }))
  } catch (error) {
    console.error('### error', error)
    logAppError({
      Component: 'OverviewMessage',
      Method: 'getMessageContentCallback',
      appError: error
    })
    set(pageState, prev => ({
      ...prev,
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger'
    }))
  }
}

export const getTrackingInfoCustomParamsCallback = ({ set }) => async () => {
  try {
    const resp = await getTrackingInfoCustomParams()
    return resp
  } catch (error) {
    console.error('### error', error)
    logAppError({
      Component: 'OverviewMessage',
      Method: 'getTrackingInfoCustomParamsCallback',
      appError: error
    })
    set(pageState, prev => ({
      ...prev,
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger'
    }))
  }
}

export const getDynamicFieldsCallback = ({ set }) => async () => {
  try {
    const resp = await getDynamicFields()
    set(dynamicFiledListState, prev => ({ ...prev, dynamicFiledList: resp }))
    return resp
  } catch (error) {
    console.error('### error', error)
    logAppError({
      Component: 'OverviewMessage',
      Method: 'getDynamicFieldsCallback',
      appError: error
    })
    set(pageState, prev => ({
      ...prev,
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger'
    }))
  }
}

export const getDynamicFieldsListValueCallback = ({
  set,
  snapshot
}) => async () => {
  let { fields: oldFields } = await snapshot.getPromise(messageState)
  try {
    const resp = await getDynamicFieldsListValue()
    resp.forEach(e => {
      const defaultObjectValue = oldFields.find(fe => fe.Id === e.Id)
      if (!defaultObjectValue) {
        oldFields = [...oldFields, e]
      }
    })
    set(messageState, prev => ({
      ...prev,
      fields: oldFields
    }))
    return resp
  } catch (error) {
    console.error('### error', error)
    logAppError({
      Component: 'OverviewMessage',
      Method: 'getDynamicFieldsListValueCallback',
      appError: error
    })
    set(pageState, prev => ({
      ...prev,
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger'
    }))
  }
}

export const getEndpointsListCallback = ({
  set,
  snapshot
}) => async idMessage => {
  // let { selectedEndpointsList: oldSelectedEndpointsList } = await snapshot.getPromise(messageState)
  try {
    const [endPointList, endPointAttachToList] = await Promise.all([
      getEndpointsList(),
      getEndpointsAttachToList()
    ])

    set(endpointsListState, prev => ({
      ...prev,
      endpointsList: endPointList.Items,
      endpointsAttachedToList: endPointAttachToList.Items
    }))
    return [endPointList.Items, endPointAttachToList.Items]
  } catch (error) {
    console.error('### error', error)
    logAppError({
      Component: 'OverviewMessage',
      Method: 'getEndpointsListCallback',
      appError: error
    })
    set(pageState, prev => ({
      ...prev,
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger'
    }))
  }
}

export const saveDinamicFieldCallback = ({ set, snapshot }) => async () => {
  set(pageState, prev => ({ ...prev, loading: true }))

  const { id, fields } = await snapshot.getPromise(messageState)
  try {
    await updateMessageDynamicFields(id, { fields })
  } catch (error) {
    console.error('### error', error)
    logAppError({
      Component: 'OverviewMessage',
      Method: 'saveDinamicFieldCallback',
      appError: error
    })
    set(pageState, prev => ({
      ...prev,
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger'
    }))
  }

  set(pageState, prev => ({ ...prev, loading: false }))
}

export const removeAttachmentCallback = ({
  set,
  snapshot
}) => async filename => {
  set(pageState, prev => ({
    ...prev,
    loading: true
  }))

  const { id } = await snapshot.getPromise(messageState)

  const { attachments, attachmentsMetadata } = await snapshot.getPromise(
    attachmentsState
  )

  const newAttachments = attachments.filter(({ name }) => name !== filename)

  const newAttachmentsConfig = newAttachments.map(({ name }) => name)

  const newAttachmentsMetadata = attachmentsMetadata.filter(
    ({ FileName }) => FileName !== filename
  )

  try {
    await updateAttachmentsConfiguration(id, newAttachmentsConfig)

    set(attachmentsState, prev => ({
      ...prev,
      attachments: newAttachments,
      attachmentsMetadata: newAttachmentsMetadata
    }))
  } catch (error) {
    logAppError({
      Component: 'OverviewMessage',
      Method: 'removeAttachmentCallback',
      appError: error
    })
    set(pageState, prev => ({
      ...prev,
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger'
    }))
  }

  set(pageState, prev => ({
    ...prev,
    loading: false
  }))
}

export const downloadAttachmentCallback = ({
  set,
  snapshot
}) => async filename => {
  const { id } = await snapshot.getPromise(messageState)

  try {
    const attachment = await downloadAttachment(id, filename)
    return attachment
  } catch (error) {
    logAppError({
      Component: 'OverviewMessage',
      Method: 'downloadAttachmentCallback',
      appError: error
    })
    set(pageState, prev => ({
      ...prev,
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger'
    }))
  }
}

export const uploadAttachmentsCallback = ({
  set,
  snapshot,
  reset
}) => async files => {
  const { id } = await snapshot.getPromise(messageState)
  const { attachments } = await snapshot.getPromise(attachmentsState)

  const { newAttachments, ...validation } = validateAttachments(
    files,
    attachments
  )

  try {
    await newAttachments.reduce(async (previousStep, file) => {
      await previousStep

      const uploadingItem = {
        name: file.name,
        size: Math.floor(file.size / 1024)
      }
      set(uploaderState, prev => ({
        ...prev,
        variant: UPLOADER_VARIANT_UPLOADING,
        uploading: uploadingItem
      }))

      await uploadAttachment(id, file)

      //
      set(attachmentsState, ({ attachments, ...prev }) => ({
        ...prev,
        attachments: [...attachments, uploadingItem]
      }))
      return Promise.resolve()
    }, Promise.resolve())

    const newAttachmentsConfig = [
      ...attachments.map(({ name }) => name),
      ...newAttachments.map(({ name }) => name)
    ]

    await updateAttachmentsConfiguration(id, newAttachmentsConfig)

    set(attachmentsState, ({ attachmentsMetadata, ...prev }) => ({
      ...prev,
      attachmentsMetadata: [
        ...attachmentsMetadata,
        ...newAttachments.map(({ name, size }) => ({
          FileName: name,
          FileSize: Math.floor(size / 1024)
        }))
      ]
    }))

    const feedback = getUploadFeedback(validation)

    set(uploaderState, prev => ({
      ...prev,
      variant: feedback ? UPLOADER_VARIANT_DANGER : UPLOADER_VARIANT_DEFAULT,
      hintDanger: feedback
    }))
  } catch (error) {
    console.error('### uploadAttachmentsCallback', error)
    logAppError({
      Component: 'OverviewMessage',
      Method: 'uploadAttachmentsCallback',
      appError: error
    })
    set(pageState, prev => ({
      ...prev,
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger'
    }))
  } finally {
    setTimeout(() => {
      reset(uploaderState)
    }, 3000)
  }
}

export const callbackAddToWhiteList = ({
  set,
  snapshot
}) => async idMessage => {
  set(pageState, prev => ({ ...prev, loading: true }))
  const loginType = storeGet(STORE_KEY_LOGIN_TYPE)
  const {
    addToWhiteList,
    silencedCheck,
    blockToDisplay
  } = await snapshot.getPromise(modalCheckup)

  try {
    if (silencedCheck) {
      const silencedAlerts = await getSilencedAlerts()
      const silencedAlertsArrayUpdated =
        silencedAlerts.DataValue && silencedAlerts.DataValue !== ''
          ? JSON.parse(silencedAlerts.DataValue)
          : []
      // mostrati e da disabilitare per il messaggio corrente
      // const displayed = objArray.filter(e => e.shown)
      blockToDisplay.forEach(e => {
        const index = silencedAlertsArrayUpdated.findIndex(
          f => f.issueType === e.issueType
        )
        if (index > -1) {
          // faccio il push nel disableForMessage se non esiste
          const exsist = silencedAlertsArrayUpdated[
            index
          ].disableForMessage.includes(idMessage.toString())
          if (!exsist) {
            silencedAlertsArrayUpdated[index].disableForMessage.push(
              idMessage.toString()
            )
          }
        } else {
          const obj = {
            issueType: e.issueType,
            disableForMessage: [idMessage.toString()]
          }
          silencedAlertsArrayUpdated.push(obj)
        }
      })
      if (loginType === LOGIN_TYPE_WEBLOGIN) {
        await addSilencedAlerts(silencedAlertsArrayUpdated)
      }
    }
    if (loginType === LOGIN_TYPE_WEBLOGIN) {
      await updateWhitelist(idMessage, addToWhiteList)
    }
  } catch (error) {
    console.error('### error', error)
    logAppError({
      Component: 'OverviewMessage',
      Method: 'callbackAddToWhiteList',
      appError: error
    })
    set(pageState, prev => ({
      ...prev,
      loading: false,
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger'
    }))
  }
  set(pageState, prev => ({
    ...prev,
    loading: false
  }))
}

export const manageFooterCallback = ({ set, snapshot }) => async (
  idMessage,
  isTrial,
  isRetailer
) => {
  set(footerState, prev => ({
    ...prev,
    state: 'loading'
  }))
  try {
    const loginType = storeGet(STORE_KEY_LOGIN_TYPE)
    const loginTypeWL = loginType === LOGIN_TYPE_WEBLOGIN

    const mandatorySenderData = await getMandatorySenderAction()

    const isCompleted = checkMandatorySenderDataCompleted(mandatorySenderData)

    if (isCompleted || isTrial || isRetailer) {
      set(footerState, prev => ({
        ...prev,
        state: 'ready',
        isCompleted: isCompleted,
        data: setMandatorySenderData(mandatorySenderData),
        dataTooltip: setMandatorySenderDataTooltip(mandatorySenderData)
      }))
    } else if (!isTrial && !isRetailer) {
      if (loginTypeWL) {
        const init = await initMandatorySenderWithAnagraphicDataAction()

        set(footerState, prev => ({
          ...prev,
          state: 'ready',
          isCompleted: isCompleted,
          isCompletedAfterInit: checkMandatorySenderDataCompleted(init),
          data: setMandatorySenderData(init),
          dataTooltip: setMandatorySenderDataTooltip(init)
        }))
        if (checkMandatorySenderDataCompleted(init)) {
          toastShow(
            getIntl().formatMessage({
              id: 'Load.SavedEmailWizard.FooterBoxSuccessWarning'
            }),
            TOAST_VARIANT_SUCCESS,
            'FooterBoxSuccessWarning',
            true
          )

          pendoTrack('Info Footer - Green alert Impression (overview)', {
            idMessage: idMessage,
            idList: storeGet(STORE_KEY_ID_LIST),
            dateTime: new Date().toISOString
          })
        }
      } else {
        set(footerState, prev => ({
          ...prev,
          state: 'ready'
        }))
      }
    }
  } catch (error) {
    logAppError({
      Component: 'OverviewMessage',
      Method: 'manageFooterCallback',
      appError: error
    })
    set(footerState, prev => ({
      ...prev,
      state: 'error'
    }))
  }
}

function checkMandatorySenderDataCompleted(mandatorySenderData) {
  if (
    mandatorySenderData &&
    mandatorySenderData.CompanyName &&
    mandatorySenderData.Address &&
    mandatorySenderData.City &&
    mandatorySenderData.StateOrProvince &&
    mandatorySenderData.PostalCode &&
    mandatorySenderData.Country &&
    mandatorySenderData.Phone &&
    mandatorySenderData.PermissionReminder
  ) {
    return true
  } else {
    return false
  }
}

function setMandatorySenderData(mandatorySenderData) {
  return (
    mandatorySenderData.CompanyName +
    ' - ' +
    (mandatorySenderData.ContactName
      ? mandatorySenderData.ContactName + ' - '
      : '') +
    mandatorySenderData.Address +
    ' - ' +
    mandatorySenderData.City +
    ' - ' +
    mandatorySenderData.StateOrProvince +
    ' - ' +
    mandatorySenderData.PostalCode +
    ' - ' +
    mandatorySenderData.Country +
    ' - ' +
    mandatorySenderData.Phone +
    ' - ' +
    mandatorySenderData.PermissionReminder
  )
}

function setMandatorySenderDataTooltip(mandatorySenderData) {
  return (
    mandatorySenderData.CompanyName +
    ' - ' +
    (mandatorySenderData.ContactName
      ? mandatorySenderData.ContactName + ' - '
      : '') +
    mandatorySenderData.Address +
    ' - ' +
    mandatorySenderData.City +
    ' - ' +
    mandatorySenderData.StateOrProvince +
    ' - ' +
    mandatorySenderData.PostalCode +
    ' - ' +
    mandatorySenderData.Country +
    ' - ' +
    mandatorySenderData.Phone +
    '<br>' +
    mandatorySenderData.PermissionReminder
  )
}

export const setActiveMessageCallback = ({ set, snapshot }) => async () => {
  const { messageType, id } = await snapshot.getPromise(messageState)
  const hasWelcomeSeries = await snapshot.getPromise(hasWelcomeSeriesState)

  try {
    await setActiveMessageOfType(id, messageType)
    set(notificationState, prev => ({ ...prev, activeMessage: id }))

    toastShow(
      getIntl().formatMessage({
        id: 'Load.Alerts.SuccessUpdate'
      }),
      TOAST_VARIANT_SUCCESS,
      'setActiveConfirmationMessageCallbackSuccess',
      false,
      false
    )
    set(modalConfirmChangeDefaultMessageState, prev => ({
      ...prev,
      show: false
    }))
    if (messageType === MESSAGE_STR_TYPE_WELCOME && !hasWelcomeSeries) {
      set(modalConfirmChangeDefaultMessageState, prev => ({
        ...prev,
        showInfo: true
      }))
    }
  } catch (error) {
    logAppError({
      appError: error,
      Component: 'OverviewMessage',
      Method: 'setActiveMessageCallback'
    })
    toastShow(
      getIntl().formatMessage({
        id: 'Load.Alerts.ErrorGeneric'
      }),
      TOAST_VARIANT_WARNING,
      'setActiveMessageCallback',
      true
    )
    set(pageState, prev => ({
      ...prev,
      loading: false,
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger'
    }))
  }
}

export const downloadHtmlMessageCallback = ({
  snapshot,
  set
}) => async idMessage => {
  let ret
  set(pageState, prev => ({
    ...prev,
    downloadFile: true
  }))
  const showToast = () => {
    toastShow(
      getIntl().formatMessage({
        id: 'Load.EmailMessageOverview.DownloadError'
      }),
      TOAST_VARIANT_ERROR,
      'DownloadHtmlError'
    )
  }
  try {
    const content = await getMessageHtmlExport(idMessage)
    if (content) {
      ret = content.Content
    } else {
      showToast()
    }
  } catch (error) {
    showToast()
  }
  set(pageState, prev => ({
    ...prev,
    downloadFile: false
  }))
  return ret
}

export const downloadPdfMessageCallback = ({
  snapshot,
  set
}) => async idMessage => {
  let ret
  set(pageState, prev => ({
    ...prev,
    downloadFile: true
  }))
  const showToast = () => {
    toastShow(
      getIntl().formatMessage({
        id: 'Load.EmailMessageOverview.DownloadError'
      }),
      TOAST_VARIANT_ERROR,
      'DownloadHtmlError'
    )
  }
  try {
    const content = await getMessagePdfExport(idMessage)
    if (content) {
      ret = content.Content
    } else {
      showToast()
    }
  } catch (error) {
    showToast()
  }
  set(pageState, prev => ({
    ...prev,
    downloadFile: false
  }))
  return ret
}

export const getScreenshotCallback = ({ set, snapshot }) => async () => {
  const { Domain } = storeGet(STORE_KEY_ACCOUNT)
  const { id, updateDate, hasThumbnail } = await snapshot.getPromise(
    messageState
  )
  set(overviewThumbnailState, prev => ({ ...prev, status: 'loading' }))

  try {
    if (id) {
      const ts = updateDate
        ? new Date(updateDate)
            .toISOString()
            .replace(/[-:.TZ]/g, '')
            .substring(0, 14)
        : ''
      if (hasThumbnail) {
        const url = `//${Domain}/messagepreview/${id}_268x321.jpg?ts=${ts}`
        set(overviewThumbnailState, prev => ({
          ...prev,
          url,
          status: 'loaded'
        }))
      } else {
        try {
          await getScreenshot(id)
          const url = `//${Domain}/messagepreview/${id}_268x321.jpg?ts=${ts}`
          set(overviewThumbnailState, prev => ({
            ...prev,
            url,
            status: 'loaded'
          }))
        } catch (error) {
          logAppError({ appError: error })
          set(overviewThumbnailState, prev => ({
            ...prev,
            status: 'error'
          }))
        }
      }
    }
  } catch (error) {
    logAppError({
      appError: error,
      Component: 'OverviewMessage',
      Method: 'getScreenshotCallback',

      Data: JSON.stringify({ id })
    })
    set(overviewThumbnailState, prev => ({ ...prev, status: 'error' }))
  }
}
